import JawsAvatarArtwork from '../components/Avatars/AvatarArtworkJaws';
import TotoAvatarArtwork from '../components/Avatars/AvatarArtworkToto';
import HollyAvatarArtwork from '../components/Avatars/AvatarArtworkHollyAvatar';
import HalAvatarArtwork from '../components/Avatars/AvatarArtworkHalAvatar';
import MorpheusAvatarArtwork from '../components/Avatars/AvatarArtworkMorpheus';
import SootSpriteAvatarArtwork from '../components/Avatars/AvatarArtworkSootSprite';
import KillerBunnyAvatarArtwork from '../components/Avatars/AvatarArtworkKillerBunny';
import SortingHatAvatarArtwork from '../components/Avatars/AvatarArtworkSortingHat';
import XenomorphAvatarArtwork from '../components/Avatars/AvatarArtworkXenomorph';
import JackSparrowAvatarArtwork from '../components/Avatars/AvatarArtworkJackSparrow';
import LegolasAvatarArtwork from '../components/Avatars/AvatarArtworkLegolas';
import LeiaAvatarArtwork from '../components/Avatars/AvatarArtworkLeia';
import AvatarArtworkStorm from '../components/Avatars/AvatarArtworkStorm';
import AvatarArtworkZero from '../components/Avatars/AvatarArtworkZero';
import AvatarArtworkPaleMan from '../components/Avatars/AvatarArtworkPaleMan';
import { NemoAvatarArtwork } from '../components/Avatars/AvatarArtworkNemo';
import { NeytiriAvatarArtwork } from '../components/Avatars/AvatarArtworkNeytiri';
import { AvatarArtworkEvelynWang } from '../components/Avatars/AvatarArtworkEvelynWang';
import { ArtworkJackieBrown } from '../components/Avatars/AvatarArtworkJackieBrown';
import { ArtworkWeirdBarbie } from '../components/Avatars/AvatarArtworkWeirdBarbie';
import { ArtworkGodzilla } from '../components/Avatars/AvatarArtworkGodzilla';
import { AvatarArtworkElphaba } from '../components/Avatars/AvatarArtworkElphaba';
import { AvatarArtworkGalinda } from '../components/Avatars/AvatarArtworkGalinda';
import { AvatarArtworkChani } from '../components/Avatars/AvatarArtworkChani';
import AvatarArtworkIronGiant from '../components/Avatars/AvatarArtworkIronGiant';
import AvatarArtworkBlacula from '../components/Avatars/AvatarArtworkBlacula';
import { SussieAvatarArtwork } from '../components/Avatars/AvatarArtworkSussie';
import { MoonAvatarArtwork } from '../components/Avatars/AvatarArtworkMoon';
import { SmokeStackAvatarArtwork } from '../components/Avatars/AvatarArtworkSmokeStack';
import { AvatarComponentProps } from '../util/types';
import { ReactNode } from 'react';
import { avatarDefaultBackgroundColors } from './avatarColors';

let avatars = {
  sussie: {
    id: 'sussie',
    name: 'Sussie',
    fromMovie: 'K-Pop Demon Hunters',
    fromYear: 2025,
    defaultBackgroundColor: avatarDefaultBackgroundColors.sussie,
    ArtworkComponent: SussieAvatarArtwork,
  },
  smokeStack: {
    id: 'smokeStack',
    name: 'Smoke/Stack',
    fromMovie: 'Sinners',
    fromYear: 2025,
    defaultBackgroundColor: avatarDefaultBackgroundColors.smokeStack,
    ArtworkComponent: SmokeStackAvatarArtwork,
    helpTextKey: 'avatarTipSmokeStack',
  },
  elphaba: {
    id: 'elphaba',
    name: 'Elphaba',
    fromMovie: 'Wicked',
    fromYear: 2024,
    defaultBackgroundColor: avatarDefaultBackgroundColors.elphaba,
    ArtworkComponent: AvatarArtworkElphaba,
  },
  galinda: {
    id: 'galinda',
    name: 'Galinda',
    fromMovie: 'Wicked',
    fromYear: 2024,
    defaultBackgroundColor: avatarDefaultBackgroundColors.galinda,
    ArtworkComponent: AvatarArtworkGalinda,
  },
  godzilla: {
    id: 'godzilla',
    name: 'Godzilla',
    fromMovie: 'Godzilla Minus One',
    fromYear: 2023,
    defaultBackgroundColor: avatarDefaultBackgroundColors.godzilla,
    ArtworkComponent: ArtworkGodzilla,
  },
  weirdBarbie: {
    id: 'weirdBarbie',
    name: 'Weird Barbie',
    fromMovie: 'Barbie',
    fromYear: 2023,
    defaultBackgroundColor: avatarDefaultBackgroundColors.weirdBarbie,
    ArtworkComponent: ArtworkWeirdBarbie,
  },
  evelynWang: {
    id: 'evelynWang',
    name: 'Evelyn Wang',
    fromMovie: 'Everything Everywhere All at Once',
    fromYear: 2022,
    defaultBackgroundColor: avatarDefaultBackgroundColors.evelynWang,
    ArtworkComponent: AvatarArtworkEvelynWang,
  },
  chani: {
    id: 'chani',
    name: 'Chani',
    fromMovie: 'Dune',
    fromYear: 2021,
    defaultBackgroundColor: avatarDefaultBackgroundColors.chani,
    ArtworkComponent: AvatarArtworkChani,
  },
  AVATAR_9: {
    id: 'AVATAR_9',
    name: 'Zero',
    fromMovie: 'The Grand Budapest Hotel',
    fromYear: 2014,
    defaultBackgroundColor: avatarDefaultBackgroundColors.AVATAR_9,
    ArtworkComponent: AvatarArtworkZero,
  },
  neytiri: {
    id: 'neytiri',
    name: 'Neytiri',
    fromMovie: 'Avatar',
    fromYear: 2009,
    defaultBackgroundColor: avatarDefaultBackgroundColors.neytiri,
    ArtworkComponent: NeytiriAvatarArtwork,
  },
  paleMan: {
    id: 'paleMan',
    name: 'Pale Man',
    fromMovie: 'Pan\'s Labyrinth',
    fromYear: 2006,
    defaultBackgroundColor: avatarDefaultBackgroundColors.paleMan,
    ArtworkComponent: AvatarArtworkPaleMan,
  },
  nemo: {
    id: 'nemo',
    name: 'Nemo',
    fromMovie: 'Finding Nemo',
    fromYear: 2003,
    defaultBackgroundColor: avatarDefaultBackgroundColors.nemo,
    ArtworkComponent: NemoAvatarArtwork,
  },
  jackSparrow: {
    id: 'jackSparrow',
    name: 'Jack Sparrow',
    fromMovie: 'Pirates of the Caribbean',
    fromYear: 2003,
    defaultBackgroundColor: avatarDefaultBackgroundColors.jackSparrow,
    ArtworkComponent: JackSparrowAvatarArtwork,
  },
  AVATAR_4: {
    id: 'AVATAR_4',
    name: 'Soot Sprite',
    fromMovie: 'Spirited Away',
    fromYear: 2001,
    defaultBackgroundColor: avatarDefaultBackgroundColors.AVATAR_4,
    ArtworkComponent: SootSpriteAvatarArtwork,
  },
  legolas: {
    id: 'legolas',
    name: 'Legolas',
    fromMovie: 'The Lord of the Rings',
    fromYear: 2001,
    defaultBackgroundColor: avatarDefaultBackgroundColors.legolas,
    ArtworkComponent: LegolasAvatarArtwork,
  },
  AVATAR_5: {
    id: 'AVATAR_5',
    name: 'Sorting Hat',
    fromMovie: 'Harry Potter and the Sorcerer\'s Stone',
    fromYear: 2001,
    defaultBackgroundColor: avatarDefaultBackgroundColors.AVATAR_5,
    ArtworkComponent: SortingHatAvatarArtwork,
  },
  AVATAR_10: {
    id: 'AVATAR_10',
    name: 'Storm',
    fromMovie: 'X-Men',
    fromYear: 2000,
    defaultBackgroundColor: avatarDefaultBackgroundColors.AVATAR_10,
    ArtworkComponent: AvatarArtworkStorm,
  },
  ironGiant: {
    id: 'ironGiant',
    name: 'Iron Giant',
    fromMovie: 'The Iron Giant',
    fromYear: 1999,
    defaultBackgroundColor: avatarDefaultBackgroundColors.ironGiant,
    ArtworkComponent: AvatarArtworkIronGiant,
  },
  AVATAR_3: {
    id: 'AVATAR_3',
    name: 'Morpheus',
    fromMovie: 'The Matrix',
    fromYear: 1999,
    defaultBackgroundColor: avatarDefaultBackgroundColors.AVATAR_3,
    ArtworkComponent: MorpheusAvatarArtwork,
  },
  jackieBrown: {
    id: 'jackieBrown',
    name: 'Jackie Brown',
    fromMovie: 'Jackie Brown',
    fromYear: 1997,
    defaultBackgroundColor: avatarDefaultBackgroundColors.jackieBrown,
    ArtworkComponent: ArtworkJackieBrown,
  },
  AVATAR_7: {
    id: 'AVATAR_7',
    name: 'Xenomorph',
    fromMovie: 'Alien',
    fromYear: 1979,
    defaultBackgroundColor: avatarDefaultBackgroundColors.AVATAR_7,
    ArtworkComponent: XenomorphAvatarArtwork,
  },
  leia: {
    id: 'leia',
    name: 'Leia',
    fromMovie: 'Star Wars',
    fromYear: 1977,
    defaultBackgroundColor: avatarDefaultBackgroundColors.leia,
    ArtworkComponent: LeiaAvatarArtwork,
  },
  AVATAR_1: {
    id: 'AVATAR_1',
    name: 'Killer Bunny',
    fromMovie: 'Monty Python and the Holy Grail',
    fromYear: 1975,
    defaultBackgroundColor: avatarDefaultBackgroundColors.AVATAR_1,
    ArtworkComponent: KillerBunnyAvatarArtwork,
  },
  AVATAR_0: {
    id: 'AVATAR_0',
    name: 'Jaws',
    fromMovie: 'Jaws',
    fromYear: 1975,
    defaultBackgroundColor: avatarDefaultBackgroundColors.AVATAR_0,
    ArtworkComponent: JawsAvatarArtwork,
  },
  blacula: {
    id: 'blacula',
    name: 'Blacula',
    fromMovie: 'Scream Blacula Scream',
    fromYear: 1973,
    defaultBackgroundColor: avatarDefaultBackgroundColors.blacula,
    ArtworkComponent: AvatarArtworkBlacula,
  },
  AVATAR_8: {
    id: 'AVATAR_8',
    name: 'Hal 9000',
    fromMovie: '2001: A Space Odyssey',
    fromYear: 1968,
    defaultBackgroundColor: avatarDefaultBackgroundColors.AVATAR_8,
    ArtworkComponent: HalAvatarArtwork,
  },
  AVATAR_2: {
    id: 'AVATAR_2',
    name: 'Holly Golightly',
    fromMovie: 'Breakfast at Tiffany\'s',
    fromYear: 1961,
    defaultBackgroundColor: avatarDefaultBackgroundColors.AVATAR_2,
    ArtworkComponent: HollyAvatarArtwork,
  },
  AVATAR_6: {
    id: 'AVATAR_6',
    name: 'Toto',
    fromMovie: 'The Wizard of Oz',
    fromYear: 1939,
    defaultBackgroundColor: avatarDefaultBackgroundColors.AVATAR_6,
    ArtworkComponent: TotoAvatarArtwork,
  },
  moon: {
    id: 'moon',
    name: 'The Moon',
    fromMovie: 'A Trip to the Moon',
    fromYear: 1902,
    defaultBackgroundColor: avatarDefaultBackgroundColors.moon,
    ArtworkComponent: MoonAvatarArtwork,
  },
} as const satisfies Record<
  string,
  {
    id: string;
    name: string;
    fromMovie: string;
    fromYear: number;
    defaultBackgroundColor: string;
    ArtworkComponent: (props: AvatarComponentProps) => ReactNode;
    helpTextKey?: string;
  }
>;

export default avatars;